<template>
  <div class="documentation">
    <Breadcumb title="Liste des documents pédagogiques" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card no-body class="cardcontainer">
      <!-- Table controls -->
      <b-card-body>
        <b-tabs class="nav-tabs-top nav-responsive-xl">
          <b-tab title="Gestion des catégories" active>
            <b-btn v-bind:to="'/dashboard/administration/documentation/category/add'" class="mt-3 ml-4" variant="primary">
              Ajouter une catégorie
            </b-btn>
            <div class="card-body">
              <b-table
                      :items="categoryData"
                      :fields="categoryFields"
                      :striped="true"
                      :bordered="true"
                      class="card-table">

                <template slot="Nom" slot-scope="data">
                  {{data.item.label}}
                </template>
                <template slot="Cible" slot-scope="data">
                  <b-badge v-for="user_type in data.item.user_types" variant="outline-default">{{user_type.label}}
                  </b-badge>
                </template>
                <template slot="Ordre" slot-scope="data">
                  {{ data.item.order }}
                </template>
                <template slot="actions" slot-scope="data">
                  <b-btn
                          v-bind:to="'/dashboard/administration/documentation/category/edit/' + data.item.id"
                          variant="default btn-xs icon-btn md-btn-flat"
                          v-b-tooltip.hover
                          title="Modifier">
                    <i class="ion ion-md-create"></i>
                  </b-btn>
                  <b-btn v-on:click="deleteCategory(data.item.id)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Supprimer"><i class="ion ion-md-close"></i></b-btn>
                </template>
              </b-table>
            </div>
          </b-tab>
          <b-tab title="Gestion des documents">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <b-form inline class="" @submit="searchDocument">
                    <b-select class="custom-select mr-sm-2 mb-2 mb-sm-0" v-model="target" value="Choose..." :options=userTypeData />
                    <b-btn type="submit" variant="primary">Filtrer</b-btn>
                    <b-btn v-on:click="resetSearch" variant="default" class="ml-1"><i class="ion ion-md-close"></i></b-btn>
                  </b-form>
                </div>
                <div class="col-md-6" style="text-align:right">
                    <b-btn v-bind:to="'/dashboard/administration/documentation/add/document/'" class="mb-3" variant="primary">Ajouter un
                      document
                    </b-btn>
                    <b-btn v-bind:to="'/dashboard/administration/documentation/add/article/'" class="mb-3" variant="primary">Ajouter un
                      article
                    </b-btn>
                    <b-btn v-bind:to="'/dashboard/administration/documentation/add/video/'" class="mb-3" variant="primary">Ajouter une
                      vidéo
                    </b-btn>
                </div>
              </div>

              <b-table
                      :items="documentData"
                      :fields="documentFields"
                      :striped="true"
                      :bordered="true"
                      class="card-table">

                <template slot="Nom" slot-scope="data">
                  {{data.item.label}}
                </template>
                <template slot="Catégorie" slot-scope="data">
                  {{data.item.category.label }}
                </template>
                <template slot="Type" slot-scope="data">
                  <b-badge variant="outline-success">{{data.item.filetype}}</b-badge>
                </template>
                <template slot="Cible" slot-scope="data">
                  <b-badge v-for="user_type in data.item.user_types" variant="outline-default">{{user_type.label}}
                  </b-badge>
                </template>
                <template slot="Preview" slot-scope="data">
                  <img v-bind:src="data.item.preview" style="width: 46px; height: 46px;"/>
                </template>
                <template slot="actions" slot-scope="data">
                  <b-btn v-bind:to="'/dashboard/administration/documentation/edit/' + data.item.id"
                         variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Modifier"><i
                          class="ion ion-md-create"></i></b-btn>
                  <b-btn v-on:click="deleteDocument(data.item.id)" variant="default btn-xs icon-btn md-btn-flat"
                         v-b-tooltip.hover title="Supprimer"><i class="ion ion-md-close"></i></b-btn>
                </template>
              </b-table>
            </div>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {
    ADMIN_DELETE_CATEGORY_REQUEST,
    ADMIN_DELETE_DOCUMENT_REQUEST,
    ADMIN_GET_CATEGORIES_REQUEST,
    ADMIN_GET_DOCUMENTS_REQUEST
  } from '../../_store/administration/document/actiontypes'
  import { mapState } from 'vuex'
  import Breadcumb from '../../components/breadcumb';
  import {ADMIN_GET_USERTYPES_REQUEST} from "../../_store/administration/user/actiontypes";

  export default {
    name: 'adminDocumentation',
    components: {Breadcumb, },
    mounted() {
      this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
        .then(response => {
          this.userTypeData = response.data.usertypes.map(userType => {
            return {
              value: userType.id,
              text: userType.label
            };
          });
        });
      this.$store.dispatch(ADMIN_GET_CATEGORIES_REQUEST);
      this.$store.dispatch(ADMIN_GET_DOCUMENTS_REQUEST);
    },
    computed: mapState({
      documentData: state => state.admin_document.documents,
      categoryData: state => state.admin_document.categories
    }),
    methods: {
      resetSearch(){
        this.target = null;
        this.$store.dispatch(ADMIN_GET_DOCUMENTS_REQUEST);
      },
      searchDocument: function(e){
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_DOCUMENTS_REQUEST, this.target);
      },
      deleteDocument(documentId) {
        this.$store.dispatch(ADMIN_DELETE_DOCUMENT_REQUEST, documentId)
          .then(() => {
            this.$router.push('/dashboard/administration/documentation/')
          })
      },
      deleteCategory(categoryId) {
        this.$store.dispatch(ADMIN_DELETE_CATEGORY_REQUEST, categoryId)
          .then(() => {
            this.$router.push('/dashboard/administration/documentation/')
          })
      }
    },

    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des documents pédagogiques', active: true },
        ],
        target: null,
        categoryFields: [
          {
            key: 'Nom',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Cible',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Ordre',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'actions',
            sortable: false,
            tdClass: 'align-middle'
          }
        ],
        documentFields: [
          {
            key: 'Nom',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Type',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Catégorie',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Cible',
            sortable: false,
            tdClass: 'align-middle'
          },{
            key: 'Preview',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'actions',
            sortable: false,
            tdClass: 'align-middle'
          },
        ]
      })
    },
    layout(context) {
      return 'layout'
    }
  }
</script>
